import { useState, useEffect, useRef } from 'react';
import axios from "axios";
import { Row, Col, Checkbox } from 'antd';
import WebsocketChat from './WebsocketChat';
import { PhoneTwoTone, ApiTwoTone } from '@ant-design/icons';
import { USER_SERVER, VONAGE_PHONE_NUMBER } from '../../../config'

import {
    VonageClient,
    ClientConfig,
    ConfigRegion,
    LoggingLevel
} from '@vonage/client-sdk';

function WebRTCComponent() {
    const [config] = useState(() => new ClientConfig(ConfigRegion.AP));
    const [client] = useState(() => {
        // Initialize client with optional config (default: ERROR logging, US region).
        const client = new VonageClient({
            loggingLevel: LoggingLevel.DEBUG,
            region: ConfigRegion.US
        });
        // Or update some options after initialization.
        client.setConfig(config);
        return client;
    });

    const [session, setSession] = useState();
    const [callId, setCallId] = useState(null);
    const [isCallActive, setIsCallActive] = useState(false);
    const [UserId, setUserId] = useState('');
    const [MonitorMode, setMonitorMode] = useState(false);


    // Create Session as soon as client is available
    useEffect(() => {
        function get_user_id(new_flag = false) {
            let userId = localStorage.getItem('tele_user_id');
            if (!userId || new_flag) {
                userId = 'ts' + Date.now();
                localStorage.setItem('tele_user_id', userId);
            }
            return userId;
        }

        const createSessionAsync = async (userId) => {
            if (!userId) {
                alert('userId is not set');
                return;
            }
            if (!client) return;

            try {
                const response = await axios.post(`${USER_SERVER}/get_jwt`, {username: userId});
                const token = response.data.jwt;
                // console.log('token--------->', token);

                const session = await client.createSession(token);
                console.log('after createSession --------->', session);
                setSession(session);
            } catch (error) {
                console.error("Error creating session:", error);
                alert('Error creating session:', error);
            }
        };

        const userId = get_user_id();
        setUserId(userId);
        createSessionAsync(userId);
    }, [client]);

    const startCall = async () => {
        if (client) {
            try {
                const callId = await client.serverCall({ to: VONAGE_PHONE_NUMBER });
                console.log("Call to application started", callId);
                // call 객체 저장 및 통화 상태 활성화
                setCallId(callId);
                setIsCallActive(true);
            } catch (error) {
                console.error("Call Failed:", error);
            }
        }
    };

    // 통화 종료 함수 추가
    const endCall = async () => {
        if (client && callId) {
            try {
                await client.hangup(callId);
                console.log("Call ended");
                setCallId(null);
                setIsCallActive(false);
            } catch (error) {
                console.error("End Call Failed:", error);
            }
        }
    };

    function onChangeMonitorMode(e) {
        console.log('onChangeMonitorMode', e.target.checked);
        setMonitorMode(e.target.checked);
    }

    return (
        <div style={{ marginLeft: '20px', marginRight: '20px' }}>
            <Row>
                <Col span={4}>
                    <Checkbox onChange={onChangeMonitorMode}>Monitor Mode</Checkbox>
                </Col>
            </Row>
            <Row>
                <h2>Vonage WebRTC 연결 상태: {isCallActive ? '통화중' : '대기중'}</h2>
            </Row>
            {/* <Row>
                {!isCallActive ? (
                    <button onClick={startCall} disabled={!client || !session}>
                        WebRTC 통화 시작
                    </button>
                ) : (
                    <button onClick={endCall} disabled={!callId}>
                        통화 종료
                    </button>
                )}
            </Row> */}
            <Row>
                <Col span={20} style={{ textAlign: 'center' }}>

                    {!isCallActive ? 
                        <PhoneTwoTone
                            onClick={startCall}
                            style={{
                                fontSize: '32px',
                                borderRadius: '50%',
                                border: '2px solid lightblue',
                                padding: '8px'
                            }}
                        /> :
                        <ApiTwoTone
                            onClick={endCall}
                            style={{
                                fontSize: '32px',
                                borderRadius: '50%',
                                border: '2px solid lightblue',
                                padding: '8px'
                            }}
                        />
                    }
                </Col>
            </Row>                        
            <Row>
                {MonitorMode ?
                    <WebsocketChat UserId={UserId} isCallActive={isCallActive}/>
                :
                    <></>
                }
            </Row>
        </div>
    );
}

export default WebRTCComponent;